// extracted by mini-css-extract-plugin
export default {"container":"Html_container__ibg4F"};